import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { interval, Subscription, switchMap, takeWhile } from 'rxjs';

@Component({
  selector: 'app-ertekesit',
  templateUrl: './ertekesit.component.html',
  styleUrls: ['./ertekesit.component.scss'],
})
export class ErtekesitComponent implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny = 2
  dolgozok = 0
  tanulok = 0
  felulet = 0
  import = 0
  besorolas = 0
  enaplo = 0
  dokumentumok = 0
  adatszolg = 0
  penzugy = 0
  modulok = 0
  munkatarssorok = [];
  datetime
  alkalmazk
  alkalmazv

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport
  @ViewChild("posmodal") pos: IonModal;
  segment = "3"
  bizonylattipus = 0;
  bizonylatok = ["-", "számla", "előleg számla", "díjbekérő", "nyugta", "árajánlat", "szállítólevél", "teljesítésigazolás", "stornószámla"]
  invoices

  portControl: FormControl;
  form: FormGroup;
  egyenleg: any = {}
  csegyenleg
  csegyenlegid
  kovetel
  kovetelnullaz
  jovair
  tetelek: any = []
  tetel: FormGroup;
  ebedusers = []
  loginmode

  /*  Családi nézet: gondviselő vagy a saját nevében belépő tanuló.
   *  A pénzügy a család nyilvántartása – a tanulói belépés eddig az intézményi
   *  ágra esett, mert csak a gondviselőt kezelte a feltétel. */
  get csaladiNezet(): boolean {
    return this.loginmode === 'gondviselo' || this.loginmode === 'tanulo';
  }
  userMetadata
  tombok

  pososszeg = ""
  terminals
  selectedterminal
  uzenet = "Kérés küldése a terminálnak..."
  fizetesstatus = 0
  transactionid
  private rawHttp: HttpClient;
  private pollingSub?: Subscription;
  ertekesitform: FormGroup;

  constructor(private http: HttpClient, private data: DataService,
    private formBuilder: FormBuilder, private ref: ChangeDetectorRef, private httpBackend: HttpBackend) {

    this.rawHttp = new HttpClient(this.httpBackend);

    this.portControl = this.formBuilder.control(
      { id: 142, nev: "magyar" },
      Validators.required
    );
    this.form = this.formBuilder.group({
      anyanyelv: this.portControl,
      allampolgar1: this.portControl,
      allampolgar2: this.portControl,
      alkalmazk: new FormControl("", Validators.required),
      alkalmazv: new FormControl(""),
      orszag: new FormControl({ id: 142, nev: "Magyarország" }, Validators.required)
    });
    this.tetel = this.formBuilder.group({
      tipus: new FormControl("", Validators.required),
      nev: new FormControl("", Validators.required),
      osszeg: new FormControl("", Validators.required),
      szamla: new FormControl(0),
      alrendszer: new FormControl(""),
      ev: new FormControl(""),
      honap: new FormControl(""),
      koveteles: new FormControl(""),
      dijbekero: new FormControl(false),
      biztomb: new FormControl(""),
    });
    this.ertekesitform = this.formBuilder.group({
      azonositas: new FormControl("", Validators.required),
      nev: new FormControl("")
    });
  }
  fotipusvalt(s) {

  }

  addNum(n) {
    if (n == -2 && this.pososszeg.toString().length > 0) {
      this.pososszeg = this.pososszeg.toString().slice(0, -1)
    }
    else if (n == -1 && this.pososszeg.toString().length > 0 && this.pososszeg != "0") {
      this.pososszeg += "0"
      this.pososszeg += "0"
    } else if (n > 0)
      this.pososszeg += n
    else if (n == 0 && this.pososszeg.toString().length > 0)
      this.pososszeg += n
    this.ref.detectChanges()
  }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.loginmode = (await this.data.getFromStorage("loginmode"))
    this.getData()
  }

  async getData() {
    await this.http
      .get(
        '/api/pos/terminals/' + this.sajatIntezmeny.intezmenyId,
        {

        }
      )
      .subscribe({
        next: (response) => {
          this.terminals = response
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }

  async send() {
    console.log(this.selectedterminal)
    this.pos.present()
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.selectedterminal.token
      })
    };
    this.uzenet = "Várakozás a fizetésre..."
    await this.rawHttp
      .post(
        environment.posapis.sumup + '/v0.1/merchants/' + this.selectedterminal.merchant_id + '/readers/' + this.selectedterminal.id + '/checkout',
        {
          "description": "Támogatás",
          "total_amount": {
            "value": parseInt(this.pososszeg) * 100,
            "currency": "HUF",
            "minor_unit": 2
          },
          "return_url": environment.erp+"/api/pos/payment/callback"
        },
        httpOptions
      )
      .subscribe({
        next: (response:any) => {
          //this.tombok = response
          console.log(response)
          
          this.transactionid = response.data.client_transaction_id
          this.checkPayment()
        },
        error: (error) => {
          this.cancel();
          this.data.sendToast(JSON.stringify(error),"error")
          console.error('Error fetching data:', error);
        }
      })
  }
  pollUntilStatusExists(paymentId: string) {
    return interval(500).pipe(
      switchMap(() => this.http.get<any>(`/api/pos/payment/${paymentId}`)),
      takeWhile(response => response?.status === null, true) // stop when response is NOT null
    );
  }
  async checkPayment() {
    //this.uzenet = "Fizetés ellenőrzése..."
        this.pollingSub = this.pollUntilStatusExists(this.transactionid).subscribe(result => {
      if (result !== null && result.status !== null) {
        console.log('Payment status received:', result);
        if(result.status=="failed"){
          this.uzenet="Sikertelen fizetés!"
          this.fizetesstatus=2
        }else{
          this.uzenet="Sikeres fizetés!"
          this.fizetesstatus=1
        }
        // Handle the valid result here (e.g., navigate, notify)
      } else {
        //console.log('Still null...');
      }
    });
  }
  async cancel() {
    this.data.showLoading("Storno...")
    this.pollingSub?.unsubscribe();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.selectedterminal.token
      })
    };
    await this.rawHttp
      .post(
        environment.posapis.sumup + '/v0.1/merchants/' + this.selectedterminal.merchant_id + '/readers/' + this.selectedterminal.id + '/terminate',
        {
        },
        httpOptions
      )
      .subscribe({
        next: (response) => {
          //this.tombok = response
          console.log(response)
          this.pososszeg = ""
          this.fizetesstatus=0
          this.pos.dismiss()
          this.data.hideLoading()

        },
        error: (error) => {
          this.data.hideLoading()
          console.error('Error fetching data:', error);
        }
      })
  }
 async savePayment(){
  this.data.showLoading("Mentés...")
await this.http
      .post(
        '/api/pos/payment/update/' + this.transactionid,
        {
          ...this.ertekesitform.value,
          amount: this.pososszeg,
          mid:this.selectedterminal.merchant_id,
          transaction_id:this.transactionid
          }
        
      )
      .subscribe({
        next: (response) => {
          this.ertekesitform.reset()
          this.transactionid = ""
          this.pososszeg = ""
          this.fizetesstatus=0
          this.pos.dismiss()
          this.data.hideLoading()
        },
        error: (error) => {
          this.data.hideLoading()
          console.error('Error fetching data:', error);
        }
      })
  }

}
